import ViewerContent from "@/react/story/components/viewers/ViewerContent";
import type { Block } from "@/react/story/types";
import TemplatingUtils from "@/react/story/utils/TemplatingUtils";

type Props = {
    block: Block;
};

export default function ViewerBlock(props: Props) {
    return (
        <div
            className={`flex-grow-1 viewer-block d-flex flex-column p-${props.block.config.p} gap-${props.block.config.gap} mw-100`}
            style={{ ...TemplatingUtils.style(props.block.config) }}
        >
            {props.block.contents.map(content => (
                <ViewerContent
                    key={content.uid}
                    content={content}
                />
            ))}
        </div>
    );
}
